/* eslint-disable import/named */
import { actionCreator } from 'utils';
import * as ErrorsTypes from '../types/errorsTypes';

// L O A D   E R R O R S
export function loadErrors() {
    return {
        type: ErrorsTypes.LOAD_ERRORS,
    };
}

export function loadErrorsRes(data) {
    return {
        type: actionCreator(ErrorsTypes.LOAD_ERRORS, 'res'),
        data,
    };
}

export function loadErrorsErr() {
    return {
        type: actionCreator(ErrorsTypes.LOAD_ERRORS, 'err'),
    };
}
// L O A D   E R R O R S

// S E T   E R R O R S   F I L T E R
export function setErrorsFilters(key, value) {
    return {
        type: ErrorsTypes.SET_ERRORS_FILTERS,
        key,
        value,
    };
}

export function setErrorsPagination(key, pagination) {
    return {
        type: ErrorsTypes.SET_ERRORS_PAGINATION,
        key,
        pagination,
    };
}

export function setErrorsSort(key, type) {
    return {
        type: ErrorsTypes.SET_ERRORS_SORT,
        sort: {
            key,
            type,
        },
    };
}

export function resetErrorsFilters() {
    return {
        type: ErrorsTypes.RESET_ERRORS_FILTERS,
    };
}
// S E T   E R R O R S   F I L T E R S

// T O G G L E   F O R M   E R R O R S
export function toggleErrorsStatus(data, load) {
    return {
        type: ErrorsTypes.TOGGLE_ERRORS_STATUS,
        data,
        load,
    };
}
// T O G G L E   F O R M   E R R O R S
